import setting from './setting'
import job from './job'
import join from './join'
import audit from './audit'
import pwork from './pwork'
import clocking from './clocking'

export default {
    setting,
    job,
    join,
    audit,
    pwork,
    clocking
}



// WEBPACK FOOTER //
// ./src/api/project/index.js